var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("erpトップ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/erp/settings"}},[_vm._v("セッティング")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }